<header class="header containerFluid" [class.theme-primary-font-border-fade-50]="themedBorder" flex-align="center" layout="row" layout-wrap="false">
	<h1 class="headerTitle" flex="fill">
		{{ headerText }}
	</h1>
		<div class="actions">
		<ng-content></ng-content> 
	</div>
</header>